import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import RatingStarComponent from "./RatingStarComponent";
import Colors from '../../constants/Colors';

class RatingComponent extends React.Component {
    state = {
        starPressed: 0,
    };

    handleStarPressed(starId) {
        this.setState({ starPressed: starId });

        if (this.props.handleOnPress)
            this.props.handleOnPress(starId, this.props.title);
    }

    renderStarList() {

        return (
            <View style={styles.starsContainerStyle}>

                <TouchableOpacity
                    onPress={() => this.handleStarPressed(0)}
                    style={{ width: '10%' }}
                >
                    <View style={{ width: 40, height: 40, justifyContent: 'center', alignItems: 'center' }}>
                        <Image
                            source={require('../../img/icons/rating/cross.png')}
                            style={{ width: 20, height: 20, tintColor: '#b0b0b1' }}
                            resizeMode={'contain'}
                        />
                    </View>
                </TouchableOpacity>

                <View style={{ flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'space-around' }}>
                    <RatingStarComponent
                        starId={1}
                        starPressed={this.state.starPressed}
                        onPress={this.handleStarPressed.bind(this)}
                    />
                    <RatingStarComponent
                        starId={2}
                        starPressed={this.state.starPressed}
                        onPress={this.handleStarPressed.bind(this)}
                    />
                    <RatingStarComponent
                        starId={3}
                        starPressed={this.state.starPressed}
                        onPress={this.handleStarPressed.bind(this)}
                    />
                    <RatingStarComponent
                        starId={4}
                        starPressed={this.state.starPressed}
                        onPress={this.handleStarPressed.bind(this)}
                    />
                    <RatingStarComponent
                        starId={5}
                        starPressed={this.state.starPressed}
                        onPress={this.handleStarPressed.bind(this)}
                    />
                </View>


            </View>
        )
    }

    renderTitle() {

        if (this.props.title === false) return null;

        return (
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center'}}>
                <View style={{ flex: 1, height: 1, width: '10%', backgroundColor: Colors.borderColor, marginLeft: 6, marginRight: 6 }} />
                <Text style={[{ color: Colors.inputFontColor, fontSize: 18, fontWeight: 'bold', textAlign: 'center'}, this.props.titleTextProps]}>
                    {this.props.title}
                </Text>
                <View style={{ flex: 1, height: 1, width: '10%', backgroundColor: Colors.borderColor, marginLeft: 6, marginRight: 6 }} />
            </View>
        )
    }

    render() {
        return (
            <View style={{marginTop: 20, marginBottom: 40}}>
                {this.renderTitle()}
                {this.renderStarList()}
            </View>
        )
    }
}

const styles = StyleSheet.create({
    starsContainerStyle: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    }
});

export default RatingComponent;
